import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

import formatMoney from '../../../helpers/formatMoney.js';

import combineStyles from '../../../helpers/combineStyles.js';
import LayoutStyles from '../../../styles/layout.js';
import ButtonStyles from '../../../styles/button.js';
import TypographyStyles from '../../../styles/typography.js';
import SpacingStyles from '../../../styles/helpers/spacing.js';
import ListsStyle from '../__styles__/Lists.style.js';

class QuotaNoHolder extends PureComponent {
  render() {
    const {
      serverErrors = {},
      availableQuota,
      availableLowCategoryQuota,
      caseThreeConfig,
      categories
    } = this.props;

    const errorMessage = serverErrors.base || serverErrors.contract;

    if (errorMessage) {
      return (
        <div style={{ marginTop: 15 }}>
          <strong>Observaciones</strong>
          <ul>
            <li><p>{errorMessage}</p></li>
          </ul>
        </div>
      );
    }

    const [lowCategoryConfig, highCategoryConfig] = caseThreeConfig;

    if (availableQuota <= 0 && availableLowCategoryQuota <= 0) {
      return (
        <div style={{ marginTop: 15 }}>
          <strong>Observaciones</strong>
          <ul>
            <li><p>Cliente no aplica para venta a no titular sin codeudor</p></li>
          </ul>
        </div>
      );
    }

    return (
      <>
        <div>
          <p>El cupo utilizable es de <b>{formatMoney(availableQuota)}</b> para las siguientes categorías:</p>
          {highCategoryConfig.parent_category_ids.length > 0 && (
            <ul>{highCategoryConfig.parent_category_ids.map((cat) => <li key={cat}>{categories.find(category => category.id == cat).name}</li>)}</ul>
          )}
        </div>
        <div>
          <p>El cupo utilizable es de <b>{formatMoney(availableLowCategoryQuota)}</b> para las siguientes categorías:</p>
          {lowCategoryConfig.parent_category_ids.length > 0 && (
            <ul>{lowCategoryConfig.parent_category_ids.map((cat) => <li key={cat}>{categories.find(category => category.id == cat).name}</li>)}</ul>
          )}
        </div>
      </>
    );
  }
}

const styles = theme => ({
  form: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-around',
    padding: 0
  },
  notFound: {
    marginTop: 10,
    color: 'red'
  },
  dataContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    margin: '5px 0px'
  },
  dataColumn: {
    width: '50%',
    ['@media (max-width:600px)']: {
      width: '100% !important'
    }
  },
  dataRegister: {
    margin: '2.5px 0px'
  },
  observationsList: {
    paddingLeft: 30
  },
  extraQuotaItem: {
    borderTop: 'solid 1px #BCBCBC',
    padding: 10,
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '&:last-child': {
      borderBottom: 'solid 1px #BCBCBC'
    }
  },
  queryResults: {
    marginTop: 10,
    display: 'block',
    width: '100%'
  },
  insurance: {
    margin: '2% 0 2% 0',
    flex: 1
  },
  resultContainer: {
    minHeight: 50,
    width: '100%',
    display: 'block',
    backgroundColor: '#FFF',
    borderRadius: '2px',
    boxShadow:
      '0 1px 1px 0 rgba(12,31,44,0.12), 0 2px 1px -1px rgba(0,0,0,0.12), 0 1px 3px 0 rgba(12,31,44,0.2)',
    marginBottom: theme.spacing.unit * 2,
    padding: '10px 16px'
  },
  spacer: {
    flex: 1,
    minHeight: '1px',
    minWidth: '1px'
  },
  button: {
    marginRight: 0,
    padding: '6px 8px',
    width: 100
  },
  queryQuotaDialogRoot: {
    ['@media (max-width:600px)']: {
      width: '95%',
      margin: '0 24px'
    }
  },
  queryQuotaDialogContent: {
    overflowX: 'hidden',
    overflowY: 'auto'
  },
  inputGrid: {
    padding: '6px 12px 6px 12px !important',
    ['@media (max-width:600px)']: {
      padding: '0 12px !important'
    }
  },
  grayContainer: {
    backgroundColor: '#EFF1F4',
    marginBottom: '5%',
    padding: 20
  },
  title: {
    color: '#111'
  }
});

QuotaNoHolder.propTypes = {
  classes: PropTypes.object.isRequired,
  newAlert: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired
};

export default withStyles(
  combineStyles(
    LayoutStyles,
    ButtonStyles,
    TypographyStyles,
    SpacingStyles,
    ListsStyle,
    styles
  )
)(QuotaNoHolder);
